import { ResponsiveService } from './../../../core/services/responsive.service';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from './../../../core/constants/screen-size';
import { Component, EventEmitter, OnInit, Output, Input, AfterViewInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-panel-document-info',
  templateUrl: './panel-document-info.component.html',
  styleUrls: ['./panel-document-info.component.scss']
})
export class PanelDocumentInfoComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @Input() signatureInfo = {
    isSignOnSContract: false,
    isValid: false,
    listInfo: []
  };
  public systemSignatureInfo: any;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  constructor(
    private responsiveService: ResponsiveService
  ) {
  }

  ngOnInit() {
    if (this.signatureInfo.listInfo) {
      this.systemSignatureInfo = this.signatureInfo.listInfo[this.signatureInfo.listInfo.length - 1];
      // const secondsSign = this.signatureInfo.listInfo[1];
      for (let info of this.signatureInfo.listInfo) {
        const {Reason: reason} = info;
        const regexCheckReasonOTPVi = /Viettel xác nhận khách hàng .+ đã ký OTP văn bản bằng sđt: \d+/gm;
        const regexCheckReasonOTPEn = /Viettel confirm customer .+ signed OTP document with phone number: \d+/gm;

        const regexCheckReasonImageVi = /Viettel xác nhận khách hàng .+ đã ký hợp đồng bằng hình ảnh/gm;
        const regexCheckReasonImageEn = /Viettel confirm customer .+ signed document with image/gm;
        let signInfo = {
          isOtpSign: false,
          NameOfTheSigner: '',
          signPhone: '',
          Reason: reason,
          certNo: '',
          customerName: '',
          phoneNumber: '',
          isImageSign: false
        };
        if (reason.match(regexCheckReasonOTPVi)) {
          signInfo = this.extractInfoFromOtpVietnameseReason(reason);
          info = this.updateInfo(info, signInfo);
        } else if (reason.match(regexCheckReasonOTPEn)) {
          signInfo = this.extractInfoFromOtpEnglishReason(reason);
          info = this.updateInfo(info, signInfo);

        } else if (reason.match(regexCheckReasonImageVi)) {
          signInfo = this.extractInfoFromImageVietnameseReason(reason);
          info = this.updateInfo(info, signInfo);


        } else if (reason.match(regexCheckReasonImageEn)) {
          signInfo = this.extractInfoFromImageEnglishReason(reason);
          info = this.updateInfo(info, signInfo);

        }

        // info.isOtpSign = signInfo.isOtpSign;
        // info.NameOfTheSigner = signInfo.customerName;
        // info.signPhone = signInfo.phoneNumber;
        // info.certNo = signInfo.certNo;
        // info.isImageSign = signInfo.isImageSign;
      }
    }
  }

  updateInfo(rootInfo, signInfo) {
    rootInfo.isOtpSign = signInfo.isOtpSign;
    rootInfo.NameOfTheSigner = signInfo.customerName;
    rootInfo.signPhone = signInfo.phoneNumber;
    rootInfo.certNo = signInfo.certNo;
    rootInfo.isImageSign = signInfo.isImageSign;
    return rootInfo;
  }

  extractInfoFromOtpVietnameseReason(reason: string) {
    const info = {
      isOtpSign: true,
      NameOfTheSigner: '',
      signPhone: '',
      Reason: reason,
      certNo: '',
      customerName: '',
      phoneNumber: '',
      isImageSign: false
    };
    const regxReplacePhone = new RegExp('Viettel xác nhận khách hàng .+ đã ký OTP văn bản bằng sđt: ', 'gm');
    const phoneNumber = reason.replace(regxReplacePhone, '');
    let nameAndCertNo = reason.replace('Viettel xác nhận khách hàng ', '');
    nameAndCertNo = nameAndCertNo.replace(/ đã ký OTP văn bản bằng sđt: \d+/gm, '');
    const certNo = nameAndCertNo.replace(/.+số giấy tờ: +/gm, '');
    const customerName = nameAndCertNo.replace(new RegExp(` số giấy tờ: ${certNo}`, 'gm'), '');
    info.NameOfTheSigner = customerName;
    info.phoneNumber = phoneNumber;
    info.certNo = certNo;
    info.signPhone = phoneNumber;
    info.customerName = customerName;
    return info;
  }

  extractInfoFromOtpEnglishReason(reason: string) {
    const info = {
      isOtpSign: true,
      NameOfTheSigner: '',
      signPhone: '',
      Reason: reason,
      certNo: '',
      customerName: '',
      phoneNumber: '',
      isImageSign: false
    };
    const regxReplacePhone = new RegExp('Viettel confirm customer .+ signed OTP document with phone number: ', 'gm');
    const phoneNumber = reason.replace(regxReplacePhone, '');
    let nameAndCertNo = reason.replace('Viettel confirm customer ', '');
    nameAndCertNo = nameAndCertNo.replace(/ signed OTP document with phone number: \d+/gm, '');
    const certNo = nameAndCertNo.replace(/.+paper number: +/gm, '');
    const customerName = nameAndCertNo.replace(new RegExp(` paper number: ${certNo}`, 'gm'), '');
    info.NameOfTheSigner = customerName;
    info.phoneNumber = phoneNumber;
    info.certNo = certNo;
    info.signPhone = phoneNumber;
    info.customerName = customerName;
    return info;
  }

  extractInfoFromImageVietnameseReason(reason: string) {
    const info = {
      isOtpSign: false,
      NameOfTheSigner: '',
      signPhone: '',
      Reason: reason,
      certNo: '',
      customerName: '',
      phoneNumber: '',
      isImageSign: true
    };
    let nameAndCertNo = reason.replace('Viettel xác nhận khách hàng ', '');
    nameAndCertNo = nameAndCertNo.replace(/ đã ký hợp đồng bằng hình ảnh+/gm, '');
    let certNo = nameAndCertNo.replace(/.+số giấy tờ: +/gm, '');
    const customerName = nameAndCertNo.replace(new RegExp(` số giấy tờ: ${certNo}`, 'gm'), '');
    if (customerName === certNo) {
      certNo = null;
    }
    info.NameOfTheSigner = customerName;
    info.certNo = certNo;

    info.customerName = customerName;
    return info;
  }

  extractInfoFromImageEnglishReason(reason: string) {
    const info = {
      isOtpSign: false,
      NameOfTheSigner: '',
      signPhone: '',
      Reason: reason,
      certNo: '',
      customerName: '',
      phoneNumber: '',
      isImageSign: true
    };
    let nameAndCertNo = reason.replace('Viettel confirm customer ', '');
    nameAndCertNo = nameAndCertNo.replace(/ signed document with image+/gm, '');
    let certNo = nameAndCertNo.replace(/.+paper number: +/gm, '');
    const customerName = nameAndCertNo.replace(new RegExp(` paper number: ${certNo}`, 'gm'), '');

    if (customerName === certNo) {
      certNo = null;
    }
    info.NameOfTheSigner = customerName;
    info.certNo = certNo;
    info.customerName = customerName;
    return info;
  }
  ngAfterViewInit() {
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscribeMediaBreakPointService.unsubscribe();
  }
    
}
